import type { FavouritesSummary } from '../types/favourites';

const defaults: Readonly<FavouritesSummary> = {
  loggedIn: false,
  folderCount: 0,
  productCodes: [],
};

export const favouritesSummaryBuilder = (
  favourites?: Partial<FavouritesSummary>,
): Readonly<FavouritesSummary> => ({
  ...defaults,
  ...favourites,
});
